export const ERROR = {
  REQUIRED_FEILD: 'This field is required',
};
